import React, { useEffect, useState } from "react";
import HowItWorksText from "./HowItWorksText";
// import howItWorksVideo from "../../../assets/fittrack.mp4";

export default function HowItWorksSection() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="bg-[#0e1a10] px-6 py-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Video Placeholder or Skeleton */}
        {isLoading ? (
          <div className="w-full h-[200px] md:h-[360px] bg-gray-700/30 animate-pulse rounded-xl" />
        ) : (
          <div className="w-full h-[200px] md:h-[360px] bg-black/20 border border-green-700 rounded-xl flex items-center justify-center text-green-400 text-sm">
            {/* <video
              src={howItWorksVideo}
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover rounded-xl"
            /> */}
            <span>Video coming soon</span>
          </div>
        )}

        {/* Animated Text or Skeleton (handled in HowItWorksText) */}
        <HowItWorksText />
      </div>
    </section>
  );
}
